import { AlertRootProps, Alert as ChakraAlert } from '@chakra-ui/react/alert'
import { CloseButton } from './close-button'
import * as React from 'react'

type AlertProps = Omit<AlertRootProps, 'title'> & {
  title?: React.ReactNode
  children?: React.ReactNode
  icon?: React.ReactNode
  closable?: boolean
  onClose?: () => void
  startElement?: React.ReactNode
  endElement?: React.ReactNode
}

export const Alert = React.forwardRef(function Alert(props: AlertProps, ref: React.Ref<HTMLDivElement>) {
  const { title, children, icon, closable, onClose, startElement, endElement, ...rest } = props
  return (
    <ChakraAlert.Root ref={ref} {...rest}>
      {startElement || <ChakraAlert.Indicator>{icon}</ChakraAlert.Indicator>}
      {children ? (
        <ChakraAlert.Content>
          <ChakraAlert.Title>{title}</ChakraAlert.Title>
          <ChakraAlert.Description>{children}</ChakraAlert.Description>
        </ChakraAlert.Content>
      ) : (
        <ChakraAlert.Title flex="1">{title}</ChakraAlert.Title>
      )}
      {endElement}
      {closable && (
        <CloseButton size="sm" pos="relative" top="-2" insetEnd="-2" alignSelf="flex-start" onClick={onClose} />
      )}
    </ChakraAlert.Root>
  )
})
